import styled from 'styled-components';

export const ActiveClassesAndAsssesssmentContainer = styled.div`
  -ms-overflow-style: none;
  background-color: #f4f5f8;
  height: 100vh;
  margin: 0 -0.9375rem;
  overflow-y: auto;
  padding: calc(5.0625rem + 2.5rem) 1.5rem 1.5rem 1.5rem;
  scrollbar-width: none;
  @media (max-width: 60.5rem) {
    .class-card-container {
      display: flex;
      flex-direction: column;
    }
    .profile-container {
      width: 100%;
    }
    [class*='col-3'] {
      max-width: 100% !important;
      padding: 0 0.875rem;
    }
    [class*='col-9'] {
      max-width: 100% !important;
      padding: 0 0.875rem;
      margin-top: 1rem;
    }
    [class*='col-sm'] {
      flex-basis: unset !important;
    }
    .container-active,
    .container-archive {
      width: unset !important;
    }
  }
  @media (max-width: 24.875rem) {
    [class*='col-9'] {
      margin-top: 2rem;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }
  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  .right-side {
    display: flex;
  }
  .academic-year {
    margin-left: 1rem;
  }
  .button-container {
    .active-class,
    .archive-class {
      outline: unset;
      background: transparent;
      box-sizing: border-box;
      padding: 0.687rem 1.5rem;
      font-weight: 500;
      font-size: 0.875rem;
      color: #aaaaaa;
      &.clicked {
        background-color: #ffffff;
        box-shadow: 0.0625rem 0.0625rem 0.25rem rgba(0, 0, 0, 0.04);
        color: ${({theme}) => theme.colors.text};
      }
    }

    .active-class {
      border-radius: 0.3125rem 0 0 0.3125rem;
      border: 0.0625rem solid #dedede;
    }
    .archive-class {
      border-radius: 0 0.3125rem 0.3125rem 0;
      border: 0.0625rem solid #dedede;
      border-left: unset;
    }
  }
  .title {
    color: ${({theme}) => theme.colors.text};
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.21;
    margin-bottom: unset;
  }

  .class-list {
    width: 100%;
  }
  .container-active,
  .container-archive {
    width: 100%;
  }
  [class*='col-'] {
    width: 100%;
    padding: 0 0.875rem;
  }

  @media (max-width: 43.75rem) {
    padding: 7.5rem 0.25rem 0 1.25rem;
    & {
      max-width: 43.75rem;
      overflow-x: hidden;
    }
    ::-webkit-scrollbar {
      display: block;
    }

    .right-side {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .button-container {
        margin-top: 1rem;
      }
      .academic-year {
        margin-left: unset;
        margin-top: 1rem;
      }
    }
    .class-list {
      flex-wrap: unset;
      flex-direction: column;
      button {
        width: 100%;
        .arrow-btn {
        }
      }
    }
  }
  @media (max-width: 25rem) {
    .header-section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .search-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    overflow-x: scroll;
    padding: 0rem 0rem 0rem 0rem;
    border-bottom: 0.0625rem solid #dedede;
    .bottom {
      margin-right: 2.5rem;
      border: none;
      background-color: unset;
      font-weight: 500;
      font-size: 1rem;
      outline: none;
      color: #0c181f;
      &.link {
        border-bottom: 0.125rem solid #40a1ff !important;
        color: #40a1ff;
      }
      p {
        font-weight: 500;
        font-size: 1rem;
      }
    }
  }

  .search-div::-webkit-scrollbar {
    display: none;
  }

  .my-classes-container {
    margin-top: 2rem;
  }
  .my-assessments-container {
    margin-top: 2rem;
  }
`;
